// extracted by mini-css-extract-plugin
module.exports = {"Summary":"InsightReport_Summary_Summary___zdSX"};